/**
 * integerSort — Ordenamiento de arreglo (Bubble Sort)
 *
 * Recibe un arreglo de enteros desordenado y devuelve un NUEVO
 * arreglo ordenado de menor a mayor. No modifica el original.
 * Implementado con Bubble Sort sin usar sort().
 *
 * @param {number[]} inputArray - Arreglo de enteros a ordenar
 * @returns {number[]} Nuevo arreglo ordenado ascendentemente
 *
 * @example
 * integerSort([5, -2, 10, 0, 3, -7]) // → [-7, -2, 0, 3, 5, 10]
 */
export function integerSort(inputArray) {
  // Copia para no modificar el arreglo original (spread operator)
  const result = [...inputArray];

  // Bucle externo: controla el número de pasadas.
  // Cada pasada coloca el elemento mayor al final de la parte no ordenada.
  for (let i = 0; i < result.length - 1; i++) {

    // Bucle interno: compara pares de elementos adyacentes.
    // El límite se reduce en i porque los últimos i elementos ya están ordenados.
    for (let j = 0; j < result.length - i - 1; j++) {

      // Si el elemento actual es mayor que el siguiente, se intercambian
      if (result[j] > result[j + 1]) {
        // Intercambio con variable temporal
        let temp = result[j];
        result[j] = result[j + 1];
        result[j + 1] = temp;
      }
    }
  }

  return result;
}

/** Casos de prueba oficiales del ejercicio */
export const TEST_CASES = [
  { input: [5, -2, 10, 0, 3, -7], expected: [-7, -2, 0, 3, 5, 10] },
  { input: [3, 1, 4, 1, 5, 9, 2], expected: [1, 1, 2, 3, 4, 5, 9] },
  { input: [0, -1, -5, 2],        expected: [-5, -1, 0, 2]         },
];
